import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';

// PrimeNg
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
// import { GMapModule } from 'primeng/gmap';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { ProgressBarModule } from 'primeng/progressbar';
import { StepsModule } from 'primeng/steps';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

// import components mu
import { LayoutModule } from '../layout/layout.module';
import { MassiveRoutingModule } from './massive-routing.module';
import { CreatePageComponent } from './pages/create/create.page.component';
import { ParametrizacionComponent } from './pages/create/components/parametrizacion/parametrizacion.component';
import { ServicesComponent } from './pages/program/components/services/services.component';
import { SharedModule } from '../shared/sharedComponents/shared.module';
import { DesignSystemModule } from '../shared/sharedModules/designSystem/design-system.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MuContextSettings } from '../shared/types/contextSettings.type';
import { RequestComponent } from './pages/request/request.component';
import { RequestTableComponent } from './pages/request/components/table/request-table.component';
import { ProgramComponent } from './pages/program/program.component';
import { ServicesComponent as ServicePageComponent } from './pages/services/services.component';
import { ServicesTableComponent } from './pages/services/components/table/services-table.component';
import { DeliveriesComponent } from './pages/deliveries/deliveries.component';
import { DeliveriesTableComponent } from './pages/deliveries/components/table/deliveries-table.component';
import { DeliveriesBreadCrumbComponent } from './pages/deliveries/components/bread-crumb/deliveries-bread-crumb.component';
import { DeliveriesFiltersToolbarComponent } from './pages/deliveries/components/deliveries-filters-toolbar/deliveries-filters-toolbar.component';
import { FileUploadDeliveriesFormComponent } from './pages/deliveries/components/file-upload-form/file-upload-form.component';
import { MassiveNewRoutingSearchComponent } from './pages/new-routing-search/massive-new-routing-search.component';
import { NewRoutingSearchFormComponentComponent } from './pages/new-routing-search/components/new-routing-search-form-component/new-routing-search-form-component.component';
import { MuToastService } from '../shared/sharedServices/mu-toast.service';
import { MassiveCfdiComponent } from './pages/cfdi/massive-cfdi.component';
import { FileUploadFormComponent } from './pages/cfdi/components/file-upload-form/file-upload-form.component';
import { MassiveNewRoutingCreateComponent } from './pages/new-routing-create/massive-new-routing-create.component';
import { NewRoutingCreateFormComponent } from './pages/new-routing-create/components/new-routing-create-form/new-routing-create-form.component';
import { DeliveriesMapComponent } from './pages/deliveries/components/map/deliveries-map.component';

@NgModule({
  declarations: [
    CreatePageComponent,
    ParametrizacionComponent,
    ServicesComponent,
    RequestComponent,
    ServicePageComponent,
    ProgramComponent,
    RequestTableComponent,
    ServicesTableComponent,
    DeliveriesComponent,
    DeliveriesTableComponent,
    DeliveriesBreadCrumbComponent,
    DeliveriesFiltersToolbarComponent,
    MassiveNewRoutingSearchComponent,
    NewRoutingSearchFormComponentComponent,
    MassiveCfdiComponent,
    FileUploadFormComponent,
    MassiveNewRoutingCreateComponent,
    NewRoutingCreateFormComponent,
    FileUploadDeliveriesFormComponent,
    DeliveriesMapComponent
  ],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: MuContextSettings.language('same-next-day'),
        deps: [HttpClient],
      },
      isolate: true,
    }),
    CommonModule,
    FormsModule,
    HttpClientModule,
    LayoutModule,
    SharedModule,
    MassiveRoutingModule,
    InputTextModule,
    ButtonModule,
    CheckboxModule,
    RadioButtonModule,
    AutoCompleteModule,
    BlockUIModule,
    CalendarModule,
    CardModule,
    ToastModule,
    DialogModule,
    DropdownModule,
    FileUploadModule,
    // GMapModule,
    MenuModule,
    MultiSelectModule,
    OrderListModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    StepsModule,
    TabViewModule,
    TableModule,
    SelectButtonModule,
    DesignSystemModule,
    ReactiveFormsModule,
    TooltipModule,
  ],
  providers: [
    MuToastService
  ],
})
export class MassiveModule {}
